/** NamiPainter — 2D tide staff silhouette. */
export const NamiPainter = {
  paint(ctx, _pos, radius, _entity) {
    ctx.beginPath();
    ctx.arc(0, 0, radius * 0.85, 0, Math.PI * 2);
    ctx.fillStyle = '#0e7490';
    ctx.fill();

    ctx.beginPath();
    ctx.arc(0, -radius * 0.55, radius * 0.38, 0, Math.PI * 2);
    ctx.fillStyle = '#67e8f9';
    ctx.fill();

    ctx.fillStyle = '#a5f3fc';
    ctx.fillRect(radius * 0.52, -radius * 0.65, radius * 0.12, radius * 1.1);

    ctx.beginPath();
    ctx.arc(radius * 0.58, -radius * 0.85, radius * 0.2, 0, Math.PI * 2);
    ctx.fillStyle = '#ecfeff';
    ctx.fill();
  }
};
